import {Model} from "@vuex-orm/core";

export default class ProductInternalTagProduct extends Model {
    static entity = 'productInternalTagProduct'

    static primaryKey = ['product_id', 'product_internal_tag_id']

    static fields () {
        return {
            product_id: this.number(null).nullable(),
            product_internal_tag_id: this.number(null).nullable()
        }
    }
}
